import React from "react";
import "../css/privacy.css";
import privacyBg from "../assets/privacybg.webp"; // keep your background image in src/assets/
import Topbar from "../components/Topbar";
import Header from "../components/header";
import Footer from "../screen/Footer";
import Herolast from "../screen/herolast";

const Privacy = () => {
  return (
    <>
      <Topbar />
      <Header />

      <div className="privacy-page">
        {/* Top banner with background image */}
        <header
          className="privacy-hero"
          style={{ backgroundImage: `url(${privacyBg})` }}
          role="banner"
          aria-label="Privacy banner"
        >
          <div className="privacy-hero-inner">
            <h1 className="privacy-hero-title">Privacy Policy</h1>
            <p className="privacy-hero-sub">
              At Jay Ambe AC Service, we take your privacy seriously. This privacy policy outlines the types of
              personal information we collect, how we use it, and how we protect it.
            </p>
          </div>
        </header>

        {/* Main content (single column, no external links or contact details) */}
        <main className="privacy-content" role="main" aria-labelledby="privacy-main-heading">
          <article className="policy-card" id="privacy-main-heading">
            <section className="policy-section">
              <h2>Information We Collect</h2>
              <p>
                We collect personal information when you contact us by phone or email to schedule an AC repair and
                service or when you submit a request for more information through our website contact form. The personal
                information we collect may include your name, phone number, email address, and address.
              </p>
            </section>

            <section className="policy-section">
              <h2>How We Use Your Information</h2>
              <p>
                We use your personal information to provide AC repair and service, respond to your inquiries, and
                communicate with you about our services. We may also use your information for marketing purposes, such
                as sending you promotional emails about our services. You can opt out of these emails at any time.
              </p>
            </section>

            <section className="policy-section">
              <h2>How We Protect Your Information</h2>
              <p>
                We take the security of your personal information seriously and have implemented industry–standard
                security measures to protect it. We use SSL encryption to secure data transmissions, and we regularly
                update our security systems to ensure they are up–to–date and effective.
              </p>
              <p>
                We will never sell or share your personal information with third parties without your consent, except as
                required by law or as necessary to provide our services.
              </p>
            </section>

            <section className="policy-section">
              <h2>Cookies</h2>
              <p>
                We use cookies on our website to enhance your browsing experience and to track website usage. Cookies are
                small text files that are stored on your device when you visit a website. You can disable cookies in your
                browser settings if you prefer.
              </p>
            </section>

            <section className="policy-section">
              <h2>Changes to Privacy Policy</h2>
              <p>
                We reserve the right to update this privacy policy at any time. Any changes will be posted on this page,
                and your continued use of our services following the posting of changes will constitute your acceptance
                of those changes.
              </p>
            </section>
          </article>
        </main>
      </div>

      <Herolast />
      <Footer />
    </>
  );
};

export default Privacy;
